import { render } from "./GruposAndPermissoes.vue?vue&type=template&id=7cea577a&scoped=true"
import script from "./GruposAndPermissoes.vue?vue&type=script&lang=js"
export * from "./GruposAndPermissoes.vue?vue&type=script&lang=js"

import "./GruposAndPermissoes.vue?vue&type=style&index=0&id=7cea577a&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cea577a"]])

export default __exports__